export const HERO_TITLE = 'Бенефиты'
export const HERO_TEXT =
  'Помогаем сотрудникам развиваться, отдыхать и быть в отличной форме.'
